// extracted by mini-css-extract-plugin
export default {"wrapper":"TranslationCount_wrapper__0T4YF","gradient":"TranslationCount_gradient__b-uYC","shine-lines":"TranslationCount_shine-lines__ML691"};